import { Pronouns } from '@ohell/common';
export function buildGamePlayer(options) {
    return {
        userId: options?.userId,
        handle: options?.handle,
        pronouns: options?.pronouns || Pronouns.They,
        didExit: options?.didExit || false,
        kickReason: options?.kickReason || null,
        computerPlayerId: options?.computerPlayerId || null,
    };
}
export function isGamePlayer(item) {
    const gamePlayer = item;
    return !!(gamePlayer.userId && gamePlayer.handle);
}
export function isActiveGamePlayer(player) {
    return !player.didExit;
}
export function getNextPlayerId(currentPlayerId, players) {
    const currentPlayerIndex = players.findIndex((player) => player.userId === currentPlayerId);
    if (currentPlayerIndex === -1) {
        throw new Error('currentPlayerId not in players in getNextPlayer');
    }
    let nextIndex = (currentPlayerIndex + 1) % players.length;
    while (nextIndex !== currentPlayerIndex) {
        if (isActiveGamePlayer(players[nextIndex])) {
            return players[nextIndex].userId;
        }
        nextIndex = (nextIndex + 1) % players.length;
    }
    throw new Error('could not find active player for next turn');
}
//# sourceMappingURL=GamePlayer.js.map